import { useSelectionStore } from "../state/useSelectionStore";
import { useLayerStore } from "../state/useLayerStore";
import { levelDef, type PriceLevel } from "../map/levels";

/**
 * Where the current selection sits in the hierarchy.
 *
 * Clicking a step up switches the map to that level, so you can go from a
 * neighbourhood back to its city without hunting for the right zoom.
 */
export function Breadcrumb() {
  const selection = useSelectionStore((s) => s.selection);
  const setLevelSetting = useLayerStore((s) => s.setLevelSetting);

  if (!selection) return null;

  const steps = [
    ...(selection.parents ?? []),
    { level: selection.scope, code: selection.code, name: selection.name },
  ];

  return (
    <nav className="flex flex-wrap items-center gap-x-1 gap-y-0.5 text-[11px] text-ink-soft">
      <span>Île-de-France</span>
      {steps.map((step, i) => {
        const last = i === steps.length - 1;
        return (
          <span key={`${step.level}-${step.code}`} className="flex items-center gap-1">
            <span aria-hidden>›</span>
            {last ? (
              <span className="font-medium text-ink">{step.name}</span>
            ) : (
              <button
                onClick={() => setLevelSetting(step.level as PriceLevel)}
                className="underline decoration-line underline-offset-2 hover:text-accent"
                title={`Switch to ${levelDef(step.level as PriceLevel).label.toLowerCase()}`}
              >
                {step.name}
              </button>
            )}
          </span>
        );
      })}
    </nav>
  );
}
